import React, { useState, useEffect, useCallback } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Status from 'FielderUtils/autoassign/processTaskStatus';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const baseStatusStyles = {
  'Fielder-task-auto-assigning': {
    backgroundColor: '#b7e9fc',
    colorLight: '#2489b1',
    colorDark: '#9bdcff',
  },
  'Fielder-task-auto-assigning-failed': {
    backgroundColor: '#e9343469',
    colorLight: '#c21010',
    colorDark: '#ff7b7b',
  },
  'Fielder-task-arrived': {
    backgroundColor: '#dce4009c',
    colorLight: '#dce400',
    colorDark: '#f4ff7a',
  },
  'Fielder-task-finish': {
    backgroundColor: '#3ad38e79',
    colorLight: '#137c4d',
    colorDark: '#7dffca',
  },
  'Fielder-task-managing': {
    backgroundColor: '#63a1e781',
    colorLight: '#0f5099',
    colorDark: '#b3d9ff',
  },
};
const AutoAssignTaskStatus = ({ value }) => {
  const lan = useLanguage();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const [text, setText] = useState('');
  const [colorKey, setColorKey] = useState('');
  const compute = useCallback(() => {
    switch (value) {
      case Status.EXECUTING:
        setColorKey('Fielder-task-auto-assigning');
        setText(lan.auto_assigning);
        break;

      case Status.FAILED_NO_AGENTS_AVAILABLE:
      case Status.FAILED_NO_SKILLS:
      case Status.FAILED_AVAILABLE_AGENTS_IN_MULTIPLE_TEAMS:
        setColorKey('Fielder-task-auto-assigning-failed');
        setText(lan.unsuccessful);
        break;

      case Status.RETRYING:
        setColorKey('Fielder-task-arrived');
        setText(lan.retrying);
        break;

      case Status.SUCCESSFULL:
        setColorKey('Fielder-task-finish');
        setText(lan.successful);
        break;

      case Status.WAITING:
        setColorKey('Fielder-task-managing');
        setText(lan.waiting);
        break;

      default:
        setColorKey('');
        setText('');
        break;
    }
  }, [value, lan]);

  useEffect(() => {
    compute();
  }, [compute]);
  let variant = 'body2';
  if (isXs) variant = 'caption';
  else if (isSm) variant = 'body2';
  else if (isMd) variant = 'subtitle2';

  const styleDef = baseStatusStyles[colorKey] || {};

  const containerSx = {
    width: '100%',
    borderRadius: 2,
    py: 0.5,
    px: 1.25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: styleDef.backgroundColor,
    color: isDark ? styleDef.colorDark : styleDef.colorLight,
    transition: 'color 0.3s ease',
  };

  return (
    <Box sx={containerSx}>
      <Typography variant={variant} noWrap sx={{ textAlign: 'center', fontWeight: 500 }}>
        {text}
      </Typography>
    </Box>
  );
};
export default AutoAssignTaskStatus;
//Original code:
/*import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Status from 'FielderUtils/autoassign/processTaskStatus';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
const statusStyles = {
  'Fielder-task-auto-assigning': {
    backgroundColor: '#b7e9fc',
    color: '#2489b1',
  },
  'Fielder-task-auto-assigning-failed': {
    backgroundColor: '#e9343469',
    color: '#c21010',
  },
  'Fielder-task-arrived': {
    backgroundColor: '#dce4009c',
    color: '#dce400',
  },
  'Fielder-task-finish': {
    backgroundColor: '#3ad38e79',
    color: '#137c4d',
  },
  'Fielder-task-managing': {
    backgroundColor: '#63a1e781',
    color: '#0f5099',
  },
};

const AutoAssignTaskStatus = ({ value }) => {
  const lan = useLanguage();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const [text, setText] = useState('');
  const [colorKey, setColorKey] = useState('');

  useEffect(() => {
    switch (value) {
      case Status.EXECUTING:
        setColorKey('Fielder-task-auto-assigning');
        setText(lan.executingAutoassign);
        break;
      case Status.FAILED_NO_AGENTS_AVAILABLE:
      case Status.FAILED_NO_SKILLS:
      case Status.FAILED_AVAILABLE_AGENTS_IN_MULTIPLE_TEAMS:
        setColorKey('Fielder-task-auto-assigning-failed');
        setText(lan.unsuccessful);
        break;
      case Status.RETRYING:
        setColorKey('Fielder-task-arrived');
        setText(lan.retrying);
        break;
      case Status.SUCCESSFULL:
        setColorKey('Fielder-task-finish');
        setText(lan.successful);
        break;
      case Status.WAITING:
        setColorKey('Fielder-task-managing');
        setText(lan.waiting);
        break;
      default:
        return;
    }
  }, [value, lan]);

  let variant = 'body2';
  if (isXs) variant = 'caption';
  else if (isSm) variant = 'body2';
  else if (isMd) variant = 'subtitle2';

  const sxStyle = {
    width: '100%',
    borderRadius: 2,
    py: 0.5,
    px: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'default',
    ...statusStyles[colorKey],
  };

  return (
    <Box sx={sxStyle}>
      <Typography
        variant={variant}
        noWrap
        sx={{ textAlign: 'center', fontWeight: 500 }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AutoAssignTaskStatus;
*/
